import { render, staticRenderFns } from "./DeliveryEdit.vue?vue&type=template&id=37934f26&"
import script from "./DeliveryEdit.vue?vue&type=script&lang=ts&"
export * from "./DeliveryEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports